module.exports = __webpack_public_path__ + "img/03.1a02707b.png";